<template>
  <p-card :height="computedHorizontal ? '156px' : undefined" :horizontal="computedHorizontal" cover :fill-height="!computedHorizontal" class="ktgl-learning-entry-card">
    <ktgl-document-image
      v-if="hasImage"
      :ratio="computedHorizontal ? undefined : 2.5"
      :width="computedHorizontal ? 200 : undefined"
      :height="computedHorizontal ? undefined : 150"
      :picture-id="pictureId"
      cover
    ></ktgl-document-image>
    <p-row dense column>
      <p-col shrink>
        <p-row align-top>
          <p-col grow>
            <h5>
              {{ title }}
            </h5>
          </p-col>
          <p-col v-if="!hasAccess" shrink>
            <ktgl-learning-lock :is-public="isPublic"></ktgl-learning-lock>
          </p-col>
        </p-row>
      </p-col>
      <p-col grow>
        <p class="caption-1">
          <strong v-if="subtitle">{{ $format.ellipsis(`${subtitle}`, cardSummaryMaxLength) }}</strong><span v-if="subtitle && description && descriptionCharCount !== 0"> - </span><span v-if="description">{{ $format.ellipsis(`${description}`, descriptionCharCount) }}</span>
        </p>
      </p-col>
      <p-col shrink justify-end>
        <slot name="action" :has-access="hasAccess"></slot>
      </p-col>
    </p-row>
  </p-card>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    name: 'KtglLearningContentCard',
    props: {
      title: { type: String, default: undefined },
      subtitle: { type: String, default: undefined },
      description: { type: String, default: undefined },
      isPublic: { type: Boolean, default: false },
      horizontal: { type: Boolean, default: false },
      pictureId: { type: [String, Number], default: undefined },
      hasImage: { type: Boolean, default: false },
    },
    data: () => ({
      cardSummaryMaxLength: 200,
    }),
    computed: {
      descriptionCharCount(): number {
        if (this.subtitle) {
          const subTitleLength = this.subtitle.length;
          if (subTitleLength >= this.cardSummaryMaxLength) {
            return 0;
          }
          return this.cardSummaryMaxLength - subTitleLength;
        }
        return this.cardSummaryMaxLength;
      },
      computedHorizontal(): boolean {
        return this.horizontal && this.$media.isDesktop;
      },
      hasAccess(): boolean {
        return this.$service.api.users.getHasAccessToContent(this.isPublic);
      },
    },
  });
</script>
